var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVhdl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 2h28v28h-28zm1.689.067a1.624 1.624 0 0 0 -1.626 1.625v24.622a1.625 1.625 0 0 0 1.626 1.626h24.627a1.625 1.625 0 0 0 1.626-1.626v-24.622a1.624 1.624 0 0 0 -1.626-1.625zm-.681 26.012a.911.911 0 0 0 .911.912h24.164a.911.911 0 0 0 .911-.912v-24.16a.91.91 0 0 0 -.911-.911h-24.164a.91.91 0 0 0 -.911.911z",
    fill: "#0d9b35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.52 5.502-6.662 20.989h-5.704l-6.662-20.989h4.016l5.521 17.293 5.475-17.293z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVhdl);
export default __webpack_public_path__ + "static/media/vhdl.39b8a9645353cb3b7d2a4fccc3890976.svg";
export { ForwardRef as ReactComponent };